module.exports = __webpack_public_path__ + "img/技术优势3.34c30f4e.png";